import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
  Grid
} from "@mui/material";
import moment from "moment";
import { useQuery } from "@apollo/client";
//Import from project
import "../../Style/pagestyle.scss";
import { padStartINV } from "../../Function/DynamicFn";
import { currencyFormat } from "../../Function/DynamicFn";
import EmptyData from "../Include/EmptyData";
import LoadingPage from "../Include/LoadingPage";
import FooterPagination from "../Include/FooterPagination";
import { GET_TOBE_PAID_NOT_CREATE_YET_INVOICE } from "../../Schema/ToPayInvoice";
import CreateSentToPayNotification from "./CreateSentToPayNotification"

export default function NotSendToPayInvoiceDetails({
  page,
  setPage,
  keyword,
  fromDate,
  toDate,
  academicYearId,
  paymentType
}) {

  const [limit, setLimit] = useState(8);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();
  let pageStudent = window.localStorage.getItem("pageStudent");

  // console.log("paymentType::", paymentType)

  const { refetch } = useQuery(GET_TOBE_PAID_NOT_CREATE_YET_INVOICE, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      academicYearId: academicYearId,
      fromDate: moment(fromDate)?.format("YYYY-MM-DD"),
      toDate: moment(toDate)?.format("YYYY-MM-DD"),
      typeOfPayment: paymentType,
    },
    onCompleted: ({ getToBePaidNotCreateYetWithPagination }) => {
      // console.log("getToBePaidNotCreateYetWithPagination::", getToBePaidNotCreateYetWithPagination?.data)
      if (getToBePaidNotCreateYetWithPagination?.data?.length > 0) {
        const prepareData = getToBePaidNotCreateYetWithPagination?.data?.map((row) => {

          const expireDate = new Date(row?.expiredDate)
          const toPayDate = new Date(row?.expiredDate)
          toPayDate.setDate(expireDate.getDate() + 1)

          // console.log("toPayDate::", toPayDate)

          return {
            countMonth: row?.countMonth,
            currentEnrollmentId: row?.currentEnrollmentId,
            expiredDate: row?.expiredDate,
            toPayForDate: toPayDate,
            foreignProgrammeClass: row?.foreignProgrammeClass,
            gender: row?.gender,
            generalProgrameClass: row?.generalProgrameClass,
            incomeHeadId: row?.incomeHeadId,
            incomeHeadName: row?.incomeHeadName,
            invoiceId: row?.invoiceId,
            invoice_id: row?.invoice_id,
            isCreated: row?.isCreated,
            khmerProgrammeClass: row?.khmerProgrammeClass,
            other: row?.other,
            paidAmount: row?.paidAmount,
            paidDate: row?.paidDate,
            phoneNumberFather: row?.phoneNumberFather,
            phoneNumberMother: row?.phoneNumberMother,
            studentId: row?.studentId,
            studentName: row?.studentName,
            student_id: row?.student_id,
            typeOfPayment: row?.typeOfPayment,
          }
        })

        setTableData(prepareData);
      }else{
        setTableData([]);
      }

      setPaginationData(getToBePaidNotCreateYetWithPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    refetch();
  }, [page, keyword, fromDate, toDate, academicYearId, paymentType]);

  useEffect(() => {
    if (pageStudent) {
      setPage(parseInt(pageStudent));
    } else {
      setPage(1);
    }
  }, [pageStudent]);

  // =========================== Resize width Screen ==================================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  // =========================== Ebd Resize width Screen ==============================

  return (
    <div className="page-container">
      <Box className="body-container">
        <Grid container spacing={2}>
          <Grid item xs={9}>
            <TableContainer sx={{ maxWidth: `${width}px` }}>
              <Table className="table">
                <TableHead className="header-row">
                  <TableRow>
                    <TableCell className="header-title-start">N°</TableCell>
                    <TableCell className="header-title">StudentID</TableCell>
                    <TableCell className="header-title">
                      InvoiceID
                    </TableCell>
                    <TableCell className="header-title">
                      Expire date
                    </TableCell>
                    <TableCell className="header-title">Full Name</TableCell>
                    <TableCell className="header-title" align="center">
                      Gender
                    </TableCell>
                    <TableCell className="header-title">English</TableCell>
                    <TableCell className="header-title">Khmer</TableCell>
                    <TableCell className="header-title">General</TableCell>
                    <TableCell className="header-title">Payment type</TableCell>
                    <TableCell className="header-title-end" >Income head name</TableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={15} className="body-cell">
                        <LoadingPage />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    {tableData?.length === 0 ? (
                      <TableBody className="body">
                        <TableRow className="body-row">
                          <TableCell colSpan={15} className="body-cell">
                            <EmptyData />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody
                        className="body"
                      >
                        {tableData?.map((row, index) => {
                          // console.log("row::", row)
                          return (
                            <TableRow
                              className="body-row"
                              key={index}
                            >
                              <TableCell
                                className="body-cell-start"
                              >
                                {index + paginationData?.slNo}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {row?.studentId}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {padStartINV(row?.invoiceId)}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {moment(row?.expiredDate).format("DD-MMM-YYYY")}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {row?.studentName}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                                align="center"
                              >
                                {row?.gender}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {row?.foreignProgrammeClass}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {row?.khmerProgrammeClass}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {row?.generalProgrameClass}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                {row?.typeOfPayment}
                              </TableCell>
                              <TableCell  
                                className="body-cell-end"
                              >
                                {row?.incomeHeadName}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    )}
                  </>
                )}
              </Table>
            </TableContainer>
          </Grid>

          <Grid item xs={3}>
            <TableContainer sx={{ maxWidth: `${width}px` }}>
              <Table className="table">
                <TableHead className="header-row">
                  <TableRow>
                    <TableCell className="header-title-start">To pay for</TableCell>
                    <TableCell className="header-title">To pay amount</TableCell>
                    <TableCell className="header-title-end"></TableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={15} className="body-cell">
                        <LoadingPage />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    {tableData?.length === 0 ? (
                      <TableBody className="body">
                        <TableRow className="body-row">
                          <TableCell colSpan={15} className="body-cell">
                            <EmptyData />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody
                        className="body"
                      >
                        {tableData?.map((row, index) => {
                          // console.log("row::", row)
                          return (
                            <TableRow
                              className="body-row"
                              key={index}
                            >
                              <TableCell
                                className="body-cell-start"
                              >
                                {moment(row?.toPayForDate).format("DD-MMM-YYYY")}
                              </TableCell>
                              <TableCell
                                className="body-cell"
                              >
                                $ {currencyFormat(row?.paidAmount)}
                              </TableCell>
                              <TableCell className="body-cell-end">
                                <CreateSentToPayNotification editData={row} academicYearId={academicYearId} setRefetch={refetch} />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    )}
                  </>
                )}
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        {/* =============================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
